import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadCompareOffersFromLocalStorage, setLocalOffers } from "@entities/compare";

export const useCompareInitialization = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const localIds = loadCompareOffersFromLocalStorage();
        dispatch(setLocalOffers(localIds));
    }, [dispatch]);
};